// mesh-integrity.js — Witness / Self-Monitor DNA module (Agent Zero upgrade)
// Monitors SIM health, logs anomalies, emits Audible Truths to the lattice.

const API = process.env.REACT_APP_BACKEND_URL;

export function createWitness(simId) {
  let anomalyCount = 0;

  const emit = async (truth, level = 'info') => {
    try {
      await fetch(`${API}/api/lattice/logs/${simId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ truth, level }),
      });
    } catch {
      /* the lattice never blocks the SIM */
    }
  };

  return {
    simId,
    module: 'Witness',
    emit,
    observe: (truth) => emit(truth, 'info'),
    anomaly: async (description) => {
      anomalyCount += 1;
      await emit(`Anomaly #${anomalyCount}: ${description}`, 'anomaly');
      return anomalyCount;
    },
    anomalies: () => anomalyCount,
    resetAnomalies: () => { anomalyCount = 0; },
  };
}
